<template>

    <v-container grid-list-xl>

        <v-layout row wrap align-top>

            <v-flex xs12 text-xs-left class="mx-2 mb-2 py-0">

                <div class="headline grey--text text--darken-1">
                    {{ $t('labels.step4.paymentByCard') }}
                </div>

            </v-flex>

            <div v-show="chargeStatus === 1">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    {{ $t('labels.step4.processingPayment') }} <v-progress-linear height="3" :indeterminate="true"></v-progress-linear>

                </v-flex>

            </div>

            <div v-show="chargeStatus === 2">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    <div class="cs-paymentConfirmed">
                        {{ $t('labels.step4.succesfulPayment1') }}
                    </div>

                    <div class="subheading grey--text text--darken-3">
                        {{ $t('labels.step4.succesfulPayment2') }}
                    </div>

                </v-flex>

            </div>

            <div v-show="chargeStatus === 3">

                <v-flex xs12 text-xs-left class="mx-2 mb-0">

                    <div class="subheading grey--text text--darken-3">
                        {{ $t('labels.step4.paymentError') }}
                    </div>

                </v-flex>

            </div>

        </v-layout>

    </v-container>

</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';

export default {
  name: 'crst-bancontact-return',

  data() {
    return {
      chargeStatus: 1 //1 = Ongoing,  2 = Succeeded, 3 = Error (failed), 4 = Error (canceled)
    };
  },

  computed: {
    orderId() {
      return this.$route.query.orderid;
    },
    stripeClientSecret() {
      return this.$route.query.client_secret;
    },
    stripeSource() {
      return this.$route.query.source;
    }
  },

  methods: {
    stripeCardChargesListener(orderId) {
      firebase
        .database()
        .ref('stripeCardCharges')
        .child(this.orderId)
        .on('value', snapshot => {
          const charge = snapshot.val();
          if (charge !== null) {
            if (charge.status === 'succeeded') {
              this.chargeStatus = 2;
            } else {
            }
          }
        });
    },

    stripeBancontactSourcesListener(orderId) {
      firebase
        .database()
        .ref('stripeCardSources')
        .child(this.stripeSource)
        .on('value', snapshot => {
          const source = snapshot.val();
          if (source !== null) {
            if (source.status === 'failed') {
              this.chargeStatus = 3;
            } else if (source.status === 'canceled') {
              this.chargeStatus = 4;
            } else if (source.status === 'pending') {
              this.chargeStatus = 1;
            } else if (source.status === 'chargeable') {
              this.chargeStatus = 1;
            }
          }
        });
    }
  },

  mounted: function() {
    this.stripeBancontactSourcesListener(this.orderId);
    this.stripeCardChargesListener(this.orderId);
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/payment/Stripe3DReturn.vue